













import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import NormalButton from '@/components/atom/button/NormalButton.vue';

@Component({
  components: {
    NormalButton,
  },
})
export default class CompleteDialog extends Vue {
  @Prop({default: '完了'})
  private name!: string;
  @Prop({default: '340px'})
  private width!: string | number;
  @Prop()
  private message!: string | string[];
  @Prop({default: true})
  private clickToClose!: boolean;

  @Emit('close-event')
  private close(): void {
    this.$modal.hide(this.name);
  }

  private メッセージ(): string[] {
    if (typeof this.message === 'string') {
      return [this.message];
    }
    return this.message;
  }
}
